/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CreateListRequest
 */
export interface CreateListRequest {
  /**
   *
   * @type {string}
   * @memberof CreateListRequest
   */
  name: string;
}

/**
 * Check if a given object implements the CreateListRequest interface.
 */
export function instanceOfCreateListRequest(
  value: object,
): value is CreateListRequest {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function CreateListRequestFromJSON(json: any): CreateListRequest {
  return CreateListRequestFromJSONTyped(json, false);
}

export function CreateListRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateListRequest {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
  };
}

export function CreateListRequestToJSON(json: any): CreateListRequest {
  return CreateListRequestToJSONTyped(json, false);
}

export function CreateListRequestToJSONTyped(
  value?: CreateListRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
  };
}
